__turbopack_context__.v({
  "quoteListWrapper": "QuotesList-module-scss-module__HH07Dq__quoteListWrapper",
});
